import ErrorLayout from "@r8er/layout/error";
import type { AppError } from "@r8er/lib/error";
import { tracedConsole } from "@r8er/lib/logging";
import type { NextPageContext } from "next";

export interface ErrorProps {
  error?: Pick<AppError, "id" | "message">;
}

const ErrorPage = ({ error }: ErrorProps) => (
  <ErrorLayout title="An error occurred" isApp={true}>
    <span>
      {process.env.DEBUG_ERRORS ? error?.message : "Internal server error"}
    </span>
    <br />
    <br />
    <span>
      Please try again or contact us with the following reference: <br />
      {error?.id}
    </span>
  </ErrorLayout>
);

ErrorPage.getInitialProps = ({ err, res }: NextPageContext): ErrorProps => {
  const statusCode =
    res?.statusCode ?? (err as { statusCode?: number })?.statusCode ?? 500;
  const suppliedErrorId =
    err && "id" in err && typeof err.id === "string" ? err.id : undefined;
  const reference = tracedConsole.error("Framework error rendered", {
    errorId: suppliedErrorId,
    error: err,
    statusCode,
  });

  return {
    error: {
      id: reference.errorId ?? reference.logId,
      message: err instanceof Error ? err.message : `HTTP ${statusCode}`,
    },
  };
};

export default ErrorPage;
